import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  overflow: hidden;
  border: 2px solid rgb(99, 99, 99);
  border-radius: 15px;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }

  .wistia_embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

function VideoWistiaComponent({
  videoId,
  aspectRatio = '16:9',
  autoPlay = false,
  muted = false,
  controls = true,
  responsive = true,
  paddingTopClass = 'pt-5',
  paddingBottomClass = 'pb-5'
}) {
  // Calculate padding-bottom for aspect ratio
  const getAspectRatioPadding = (ratio) => {
    const [width, height] = ratio.split(':').map(Number);
    return `${(height / width) * 100}%`;
  };

  // Generate Wistia embed URL
  const getWistiaEmbedUrl = () => {
    const params = new URLSearchParams();

    if (autoPlay) params.append('autoPlay', 'true');
    if (muted) params.append('muted', 'true');
    if (!controls) params.append('controlsVisibleOnLoad', 'false');

    const queryString = params.toString();
    return `https://fast.wistia.net/embed/iframe/${videoId}${
      queryString ? `?${queryString}` : ''
    }`;
  };

  return (
    <div
      className={`container mb-6 mt-3 ${paddingTopClass} ${paddingBottomClass}`}
    >
      <VideoContainer
        style={{
          paddingBottom: responsive
            ? getAspectRatioPadding(aspectRatio)
            : 'auto',
          height: responsive ? 0 : 'auto'
        }}
      >
        <iframe
          src={getWistiaEmbedUrl()}
          title={`Wistia video ${videoId}`}
          allowFullScreen
          allow="autoplay; fullscreen"
          loading="lazy"
        />
      </VideoContainer>
    </div>
  );
}

VideoWistiaComponent.propTypes = {
  videoId: PropTypes.string.isRequired,
  aspectRatio: PropTypes.string,
  autoPlay: PropTypes.bool,
  muted: PropTypes.bool,
  controls: PropTypes.bool,
  responsive: PropTypes.bool,
  paddingTopClass: PropTypes.string,
  paddingBottomClass: PropTypes.string
};

VideoWistiaComponent.defaultProps = {
  aspectRatio: '16:9',
  autoPlay: false,
  muted: false,
  controls: true,
  responsive: true,
  paddingTopClass: 'pt-5',
  paddingBottomClass: 'pb-5'
};

export default VideoWistiaComponent;
